import type { SuperEnhancementResponseDto } from 'app/API/models';
import { retainSuperEnhancementPreview } from './retainSuperEnhancementPreview';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import { superEnhancementApi } from './superEnhancementApi';
import { superEnhancementKeys } from './superEnhancementKeys';

export const createFetchSuperEnhancementQueryFn =
  (call: TCall) =>
  async ({ queryKey, signal, client }: QueryFunctionContext<ReturnType<typeof superEnhancementKeys.detail>>) => {
    const [{ jobId }] = queryKey;
    const response = await call(() => cancelOnSignal(superEnhancementApi.get(jobId), signal), {
      dontRedirectOnError: true,
      onError: () => {},
    });
    return retainSuperEnhancementPreview(client.getQueryData<SuperEnhancementResponseDto>(queryKey), response);
  };
